module.exports = __webpack_public_path__ + "s6.no2.9e3e41a6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s6.no2.jpg
// module id = DuRH
// module chunks = 0